import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { DocumentosEmitidosService } from 'app/modules/admin/bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/documentos-emitidos.service';
import { DataTiposGestionesBienesCulturales, ResponseTiposGestionesBienesCulturales } from 'app/modules/admin/bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/gestiones-bienes-culturales';

@Component({
    selector: 'buscador-gestiones',
    templateUrl: 'buscador-gestiones.component.html',
    imports:[
        CommonModule,
        MatFormFieldModule,
        MatTableModule,
        FormsModule,
        MatAutocompleteModule,
        MatInputModule,
        MatIconModule,
    ]
})

export class BuscadorGestionesComponent implements OnInit {
  gestionActual: string = '';
  filteredGestiones: DataTiposGestionesBienesCulturales[] = [];
  gestionesSeleccionadas: DataTiposGestionesBienesCulturales[] = [];

  @Input() tiposGestionesBienesCulturales: DataTiposGestionesBienesCulturales[] = [];

  @Output() gestionesSeleccionadasChange = new EventEmitter<DataTiposGestionesBienesCulturales[]>();

  constructor() {}

  ngOnInit() {}

  onInputChange() {
    const current = this.gestionActual.toLowerCase();
    if (current) {
      this.filteredGestiones = this.tiposGestionesBienesCulturales.filter(g =>
        g.nombre.toLowerCase().includes(current) &&
        !this.gestionesSeleccionadas.some(sel => sel.gestionUuid === g.gestionUuid)
      );
    } else {
      this.filteredGestiones = this.tiposGestionesBienesCulturales.slice();
    }
  }

  remove(gestion: DataTiposGestionesBienesCulturales): void {
    this.gestionesSeleccionadas = this.gestionesSeleccionadas.filter(g => g.gestionUuid !== gestion.gestionUuid);
    this.gestionesSeleccionadasChange.emit(this.gestionesSeleccionadas); // Emitimos al padre
    this.onInputChange();
  }

  selected(event: MatAutocompleteSelectedEvent) {
    const nombreSeleccionado = event.option.value;
    const gestion = this.tiposGestionesBienesCulturales.find(g => g.nombre === nombreSeleccionado);

    if (gestion && !this.gestionesSeleccionadas.some(g => g.gestionUuid === gestion.gestionUuid)) {
      this.gestionesSeleccionadas = [...this.gestionesSeleccionadas, gestion];
      this.gestionesSeleccionadasChange.emit(this.gestionesSeleccionadas); // Emitimos al padre
    }

    this.gestionActual = '';
    this.filteredGestiones = [];
  }
}